const userEnquiriesQuery = require('./userEnquiries');
const recentEnquiriesQuery = require('./recentEnquiries');
const createEnquiryQuery = require('./createEnquiry');

module.exports = {
  userEnquiriesQuery,
  recentEnquiriesQuery,
  createEnquiryQuery,
};
